import React, { useState } from 'react';
import './RequestResetPasswordPage.css';
function RequestResetPasswordPage() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const handlePasswordResetRequest = async (event) => {
    event.preventDefault();
    setMessage(null);
    setError(null);
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/api';
    try {
      const response = await fetch(`${API_BASE_URL}/users/request-password-reset`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        throw new Error('Failed to send reset password email. Please check the email and try again.');
      }

      const data = await response.json();
      setMessage(data.message || 'If an account with that email exists, a reset link has been sent.');
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <div className="reset-request-page">
      <h2>Request Password Reset</h2>
      <p>Please enter your email address. We will send you a link to reset your password.</p>
      <form onSubmit={handlePasswordResetRequest}>
        <label>Email address</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button type="submit">Request Password Reset</button>
      </form>
      {message && <p className="success-message">{message}</p>}
      {error && <p className="error-message">{error}</p>}
    </div>
  );
}

export default RequestResetPasswordPage;
